<!--
 * @description: 
 * @author: Jason Wong
 * @since: 2022-07-27 15:18:42
-->
<template>
  <el-form inline class="component__glossary-extract--filter-bar">
    <el-form-item v-if="layout.indexOf('frequency') > -1">
      <span>词频 >= </span>
      <ve-input-number
        class="input-number__word-count"
        size="mini"
        :min="1"
        v-model="filter.frequency"
      >
      </ve-input-number>
    </el-form-item>

    <el-form-item label="原文长度(字/词)" v-if="layout.indexOf('src') > -1">
      <ve-input-number
        class="input-number__word-count"
        size="mini"
        :min="1"
        v-model="filter.srcMinLength"
      ></ve-input-number>
      <span>&nbsp;&nbsp;~&nbsp;&nbsp;</span>
      <ve-input-number
        class="input-number__word-count"
        size="mini"
        :min="1"
        v-model="filter.srcMaxLength"
      ></ve-input-number>
    </el-form-item>

    <el-form-item label="译文长度(字/词)" v-if="layout.indexOf('tgt') > -1">
      <ve-input-number
        class="input-number__word-count"
        size="mini"
        :min="1"
        v-model="filter.tgtMinLength"
      ></ve-input-number>
      <span>&nbsp;&nbsp;~&nbsp;&nbsp;</span>
      <ve-input-number
        class="input-number__word-count"
        size="mini"
        :min="1"
        v-model="filter.tgtMaxLength"
      ></ve-input-number>
    </el-form-item>

    <el-form-item label="原文" v-if="layout.indexOf('src') > -1">
      <el-input
        size="mini"
        style="width: 150px"
        v-model="filter.src"
        placeholder="请输入原文"
      ></el-input>
    </el-form-item>

    <el-form-item label="译文" v-if="layout.indexOf('tgt') > -1">
      <el-input
        size="mini"
        style="width: 150px"
        v-model="filter.tgt"
        placeholder="请输入译文"
      ></el-input>
    </el-form-item>

    <!-- It is not avariable currently -->
    <el-form-item label="类型" v-if="false && layout.indexOf('type') > -1">
      <el-select></el-select>
    </el-form-item>

    <el-form-item label="仅查看已勾选" v-if="layout.indexOf('sel') > -1">
      <el-switch v-model="filter.onlySelectedShown"></el-switch>
    </el-form-item>

    <el-form-item v-if="layout.indexOf('reset') > -1">
      <el-button plain size="small" @click="reset">重置</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
export default {
  props: {
    filter: {
      type: Object,
      required: true,
    },
    layout: {
      type: String,
      default: "frequency,src,tgt,type,sel,reset",
    },
  },
  methods: {
    reset() {
      this.$emit("require-reset", this._initFilter);
    },
  },
  created() {
    this._initFilter = { ...(this.filter || {}) };
  },
};
</script>

<style lang="scss">
.component__glossary-extract--filter-bar {
  .input-number__word-count {
    width: 45px;
  }

  &.el-form {
    .el-form-item {
      margin-bottom: 0px;
    }
  }

  &.el-form--inline .el-form-item {
    margin-right: 20px;
  }
}
</style>